<template>
  <div v-if="show" class="dsf-sc-home-aside-select">
    <el-select v-model="value" placeholder="请选择">
      <el-option
        v-for="item in options"
        :key="item.value"
        :label="item.label"
        :value="item.value">
      </el-option>
    </el-select>
  </div>
</template>

<script>
export default {
  name: "DsfScHomeAsideSelect",
  inject: ["homeRoot"],
  data() {
    return {
      options: [{
        value: '1',
        label: '人口变动调查抽样'
      }, {
        value: '2',
        label: '规下企业调查方案'
      }],
      value: '1'
    }
  },
  computed: {
    show() {
      return this.homeRoot.menuKey?.[0] === "55320196742e4362a756c67f78269b2a";
    }
  },
  watch: {
    'value'(to) {
      // if (this.menu) {
      //   let menuChildren =  menuConfig[to] || [];
      //   this.$set(this.menu, 'children', menuConfig[to] || null);
      //   if (menuChildren.length > 0) {
      //     location.replace(menuChildren[0].menu_url);
      //   }
      // }
    }
  },
  created() {
    let menuList = this.homeRoot.menuList;
    this.menu = _.find(menuList, m => m.menu_id === '55320196742e4362a756c67f78269b2a');
    // let menu = this.menu = _.find(menuList, m => m.menu_id === '55320196742e4362a756c67f78269b2a');
    // if (menu) {
    //   this.$set(menu, 'children', menuConfig[this.value] || null);
    // }
  }
}

function getMenuItem(menu_name, menu_url, _level, children = null) {
  return {
    children,
    menu_code: null,
    menu_icon: null,
    menu_id: dsf.uuid(),
    menu_name,
    menu_opentype_text: null,
    menu_opentype_value: null,
    menu_url,
    _level,
  }
}

const menuConfig = {
  1: [
    getMenuItem('样本轮换', '#/pc/statistical/ybk/ybgl/yblh/cyk/zlcykzs', 3, [
      getMenuItem('整理抽样框', '#/pc/statistical/ybk/ybgl/yblh/cyk/zlcykzs', 4),
      getMenuItem('样本量分配', '#/pc/statistical/ybk/ybgl/yblh/yblfp2/yblfpzs', 4),
      getMenuItem('抽选调查小区', '#/pc/statistical/ybk/ybgl/yblh/dcxqybcqhls/dcxqybcqzs', 4),
      getMenuItem('落实调查小区', '#/pc/statistical/ybk/ybgl/yblh/dcxqybcqhls/lsdcxq', 4),
      getMenuItem('确认调查小区', '#/pc/statistical/ybk/ybgl/yblh/dcxqybcqhls/qrdcxq', 4),
      getMenuItem('建筑物清查表', '#/pc/statistical/ybk/ybgl/yblh/jzwqc/jzwqcbzs', 4),
      getMenuItem('住宅名录', '#/pc/statistical/ybk/ybgl/yblh/zzml/zzmlzs', 4),
    ]),
    getMenuItem('权数管理', '#/pc/statistical/ybk/ybgl/qsgl/qsmanageleftmain', 3),
    getMenuItem('样本评估', '#/pc/statistical/ybk/server/yblfx/ybbdqk', 3)
  ],
  2: [
    getMenuItem('样本轮换', '#/pc/statistical/ybk/ybgl/yblh/cykml/mlkcykz', 3, [
      getMenuItem('整理抽样框', '#/pc/statistical/ybk/ybgl/yblh/cykml/mlkcykz', 4),
      getMenuItem('样本量分配', '#/pc/statistical/ybk/ybgl/yblh/cykml/gy/yblgy', 4),
      getMenuItem('抽取企业', '#/pc/statistical/ybk/ybgl/yblh/cykml/gy/qityb', 4)
    ]),
    getMenuItem('权数管理', '#/pc/statistical/ybk/ybgl/qsgl/qsmanageleftmain', 3),
    getMenuItem('样本评估', '#/pc/statistical/ybk/server/yblfx/ybbdqk', 3)
  ]
}
</script>